import { authApi } from './authApi';

export const createProduct = async (payload: any) => {
  return await authApi.post('admin/product_master/', payload);
};

export const uploadProductFile = async (payload: any) => {
  return await authApi.post('admin/product_master/upload-file/', payload);
};

export const uploadExistingProductFile = async (payload: any) => {
  return await authApi.post('admin/product_master/check-exists/', payload);
};

export const fetchProductMaster = async (params = ''): Promise<any> => {
  return await authApi.get(`admin/product_master/${params}`);
};

export const deleteProductMaster = async (payload: { ids: number[] }) => {
  return await authApi.delete(`admin/product_master/`, {
    data: payload,
  });
};

export const exportProductMaster = async (params = ''): Promise<any> => {
  return await authApi.get(`admin/product_master/export/${params}`);
};

export const fetchEditProductData = async (id: string): Promise<any> => {
  return await authApi.get(`admin/product_master/${id}/`);
};

export const editProductData = async (payload: any) => {
  return await authApi.patch(
    `admin/product_master/${payload?.id}/`,
    payload?.body
  );
};

export const updateProductStatus = async (payload: any) => {
  return await authApi.patch(`admin/product_master/status_update/`, payload);
};

// umbrella contract
export const updateContractProduct = async (payload: any) => {
  return await authApi.patch(`contracts/update-parties/`, payload?.body);
};

// product config
export const fetchProductConfig = async (): Promise<any> => {
  return await authApi.get('admin/product_config/');
};

export const productConfigCreate = async (payload: any) => {
  return await authApi.post('admin/product_config/', payload);
};

export const editProductConfig = async (payload: any) => {
  return await authApi.patch(
    `admin/product_config/${payload?.id}/`,
    payload?.body
  );
};
